export const UAT = ["popmartth", "kovet"];
export const PROD = ["popmartth", "kovettest"];
